import React from 'react'

import noop from 'lodash/noop'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

import deleteIcon from '../../assets/icons/delete.svg'

import Icon from '../icon'
import LinkButton from '../link-button'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  button: React.ReactElement
  min?: number
  preventDeleteMin?: boolean
  onAdd?: (nextIndex: number) => void
  onDelete?: (index: number) => void
}

const Repeatable = ({
  classNames,
  children,
  button,
  min = 1,
  preventDeleteMin = false,
  onAdd = noop,
  onDelete = noop,
}: Props) => {
  const childrenCount = React.Children.count(children)

  return (
    <div className={cn('Repeatable', {}, classNames)}>
      <ul className="Repeatable__list">
        {mapChildrenWithFragments(children, (child, index) => {
          const preventDeleteItem = preventDeleteMin && index < min

          return (
            <li className="Repeatable__item" key={index}>
              <div className="Repeatable__child">{child}</div>
              {childrenCount > min && (
                <div className="Repeatable__delete">
                  {!preventDeleteItem && (
                    <LinkButton
                      size="200"
                      icon={<Icon source={deleteIcon} />}
                      onClick={() => onDelete(index)}
                    />
                  )}
                </div>
              )}
            </li>
          )
        })}
      </ul>
      {React.cloneElement(button, {
        onClick: () => onAdd(childrenCount),
      })}
    </div>
  )
}

export default Repeatable
